import React from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../redux/hooks";
import { onSetWorkorderLabels, saveWorkorderLabelRedux } from "../../../redux/slices/workorderManagement.feature";
import { IRootState } from "../../../types/redux/IRootStore";
import { useTranslation } from "react-i18next";
import FormInputNumber from "../../common/FormInputNumber";
import ReactSelectWrapper, { IReactSelectOption } from "../../common/ReactSeletWrapper";
import { Label } from "../../../types/label";
import { ReactSelectStyle } from "../../common/rectSelectStyle";
import { WorkorderLabel } from "../../../types/workorderLabel";
import FormInputText from "../../common/FormInputText";
import { parseChangeEvent } from "../../../aplUtils/formHelper";

export default function WorkorderManagementLabelsPane() {
    const { t } = useTranslation();
    const workorderManagementRedux = useSelector((state: IRootState) => state.workorderManagement);
    const dispatch = useAppDispatch();

    const languageSelectData: IReactSelectOption[] = [
        { value: "en", label: "English" },
        { value: "dk", label: "Dansk" },
        { value: "de", label: "Deutsch" },
        { value: "it", label: "Italiano" },
        { value: "nl", label: "Nederlands" },
        { value: "pl", label: "Polski" },
        { value: "sv", label: "Svenska" },
        { value: "pt", label: "Português (BR)" },
        { value: "es", label: "Español" }
    ];

    const onSubmit = (e: any) => {
        e.preventDefault();
        if(workorderManagementRedux.labelsData != null)
            dispatch(saveWorkorderLabelRedux(workorderManagementRedux.labelsData) as any);
    };

    const onChange = (e: any) => {
        e.preventDefault();

        let data = {
            ...workorderManagementRedux.labelsData,
            ...parseChangeEvent(e)
        } as WorkorderLabel;
        dispatch(onSetWorkorderLabels(data));
        // dispatch(onSetWorkorderDataDirty(true));
    };

    const labelsList: IReactSelectOption[] =
        workorderManagementRedux.labelsData?.labels == null
            ? []
            : [
                  {
                      value: "",
                      label: "None"
                  },
                  ...workorderManagementRedux.labelsData.labels.map((x: Label) => ({
                      value: x.labelName,
                      label: x.labelName
                  }))
              ];

    return (
        <React.Fragment>
            <div className="container mw-100 p-2 pt-0 mt-1">
                <form onSubmit={onSubmit} onChange={onChange}>
                    <h5 className="mb-0">{t("main.labels")}</h5>

                    <div className="row" id="div-labels-selection-1">
                        {/* label */}
                        <div className="col-3">
                            <label className="margin-bottom-02em" htmlFor="txtPalLabel">
                                Label1
                            </label>
                            <ReactSelectWrapper
                                data={labelsList}
                                isClearable={false}
                                styles={ReactSelectStyle}
                                onChange={e => {
                                    dispatch(
                                        onSetWorkorderLabels({
                                            ...workorderManagementRedux.labelsData,
                                            palLabelName: e.value
                                        } as WorkorderLabel)
                                    );
                                }}
                                value={
                                    labelsList.find(
                                        (x: any) =>
                                            x.value.toLowerCase() === workorderManagementRedux.labelsData?.palLabelName.toLowerCase()
                                    ) ?? null
                                }
                            />
                        </div>
                        {/* label language */}
                        <div className="col-3">
                            <label className="margin-bottom-02em" htmlFor="txtPalLabel">
                                Language
                            </label>
                            <ReactSelectWrapper
                                data={languageSelectData}
                                isClearable={false}
                                styles={ReactSelectStyle}
                                onChange={e => {
                                    dispatch(
                                        onSetWorkorderLabels({
                                            ...workorderManagementRedux.labelsData,
                                            palLabelLanguage: e.value
                                        } as WorkorderLabel)
                                    );
                                }}
                                value={
                                    languageSelectData.find(
                                        (x: any) =>
                                            x.value.toLowerCase() === workorderManagementRedux.labelsData?.palLabelLanguage.toLowerCase()
                                    ) ?? null
                                }
                            />
                        </div>

                        {/* test label */}
                        <div className="col-3">
                            <label className="margin-bottom-02em" htmlFor="txtPalLabel">
                                TestLabel1
                            </label>
                            <ReactSelectWrapper
                                data={labelsList}
                                isClearable={false}
                                styles={ReactSelectStyle}
                                onChange={e => {
                                    dispatch(
                                        onSetWorkorderLabels({
                                            ...workorderManagementRedux.labelsData,
                                            testPalletLabel: e.value
                                        } as WorkorderLabel)
                                    );
                                }}
                                value={
                                    labelsList.find(
                                        (x: any) =>
                                            x.value.toLowerCase() === workorderManagementRedux.labelsData?.testPalletLabel.toLowerCase()
                                    ) ?? null
                                }
                            />
                        </div>

                        {/* test label language */}
                        <div className="col-3">
                            <label className="margin-bottom-02em" htmlFor="txtPalLabel">
                                Language
                            </label>

                            <ReactSelectWrapper
                                data={languageSelectData}
                                isClearable={false}
                                styles={ReactSelectStyle}
                                onChange={e => {
                                    dispatch(
                                        onSetWorkorderLabels({
                                            ...workorderManagementRedux.labelsData,
                                            testPalletLabelLanguage: e.value
                                        } as WorkorderLabel)
                                    );
                                }}
                                value={
                                    languageSelectData.find(
                                        (x: any) =>
                                            x.value.toLowerCase() ===
                                            workorderManagementRedux.labelsData?.testPalletLabelLanguage.toLowerCase()
                                    ) ?? null
                                }
                            />
                        </div>
                    </div>

                    <div className="row" id="div-labels-selection-2">
                        {/* label */}
                        <div className="col-3">
                            <label className="margin-bottom-02em" htmlFor="txtPalLabel">
                                Label2
                            </label>
                            <ReactSelectWrapper
                                data={labelsList}
                                isClearable={false}
                                styles={ReactSelectStyle}
                                onChange={e => {
                                    dispatch(
                                        onSetWorkorderLabels({
                                            ...workorderManagementRedux.labelsData,
                                            palLabelName2: e.value
                                        } as WorkorderLabel)
                                    );
                                }}
                                value={
                                    labelsList.find(
                                        (x: any) =>
                                            x.value.toLowerCase() === workorderManagementRedux.labelsData?.palLabelName2.toLowerCase()
                                    ) ?? null
                                }
                            />
                        </div>
                        {/* label language */}
                        <div className="col-3">
                            <label className="margin-bottom-02em" htmlFor="txtPalLabel">
                                Language
                            </label>
                            <ReactSelectWrapper
                                data={languageSelectData}
                                isClearable={false}
                                styles={ReactSelectStyle}
                                onChange={e => {
                                    dispatch(
                                        onSetWorkorderLabels({
                                            ...workorderManagementRedux.labelsData,
                                            palLabelLanguage2: e.value
                                        } as WorkorderLabel)
                                    );
                                }}
                                value={
                                    languageSelectData.find(
                                        (x: any) =>
                                            x.value.toLowerCase() === workorderManagementRedux.labelsData?.palLabelLanguage2.toLowerCase()
                                    ) ?? null
                                }
                            />
                        </div>

                        {/* test label */}
                        <div className="col-3">
                            <label className="margin-bottom-02em" htmlFor="txtPalLabel">
                                TestLabel2
                            </label>
                            <ReactSelectWrapper
                                data={labelsList}
                                isClearable={false}
                                styles={ReactSelectStyle}
                                onChange={e => {
                                    dispatch(
                                        onSetWorkorderLabels({
                                            ...workorderManagementRedux.labelsData,
                                            testPalletLabel2: e.value
                                        } as WorkorderLabel)
                                    );
                                }}
                                value={
                                    labelsList.find(
                                        (x: any) =>
                                            x.value.toLowerCase() === workorderManagementRedux.labelsData?.testPalletLabel2.toLowerCase()
                                    ) ?? null
                                }
                            />
                        </div>

                        {/* test label language */}
                        <div className="col-3">
                            <label className="margin-bottom-02em" htmlFor="txtPalLabel">
                                Language
                            </label>

                            <ReactSelectWrapper
                                data={languageSelectData}
                                isClearable={false}
                                styles={ReactSelectStyle}
                                onChange={e => {
                                    dispatch(
                                        onSetWorkorderLabels({
                                            ...workorderManagementRedux.labelsData,
                                            testPalletLabelLanguage2: e.value
                                        } as WorkorderLabel)
                                    );
                                }}
                                value={
                                    languageSelectData.find(
                                        (x: any) =>
                                            x.value.toLowerCase() ===
                                            workorderManagementRedux.labelsData?.testPalletLabelLanguage2.toLowerCase()
                                    ) ?? null
                                }
                            />
                        </div>
                    </div>

                    <div className="row" id="div-labels-selection-3">
                        {/* label */}
                        <div className="col-3">
                            <label className="margin-bottom-02em" htmlFor="txtPalLabel">
                                Label3
                            </label>
                            <ReactSelectWrapper
                                data={labelsList}
                                isClearable={false}
                                styles={ReactSelectStyle}
                                onChange={e => {
                                    dispatch(
                                        onSetWorkorderLabels({
                                            ...workorderManagementRedux.labelsData,
                                            palLabelName3: e.value
                                        } as WorkorderLabel)
                                    );
                                }}
                                value={
                                    labelsList.find(
                                        (x: any) =>
                                            x.value.toLowerCase() === workorderManagementRedux.labelsData?.palLabelName3.toLowerCase()
                                    ) ?? null
                                }
                            />
                        </div>
                        {/* label language */}
                        <div className="col-3">
                            <label className="margin-bottom-02em" htmlFor="txtPalLabel">
                                Language
                            </label>
                            <ReactSelectWrapper
                                data={languageSelectData}
                                isClearable={false}
                                styles={ReactSelectStyle}
                                onChange={e => {
                                    dispatch(
                                        onSetWorkorderLabels({
                                            ...workorderManagementRedux.labelsData,
                                            palLabelLanguage3: e.value
                                        } as WorkorderLabel)
                                    );
                                }}
                                value={
                                    languageSelectData.find(
                                        (x: any) =>
                                            x.value.toLowerCase() === workorderManagementRedux.labelsData?.palLabelLanguage3.toLowerCase()
                                    ) ?? null
                                }
                            />
                        </div>

                        {/* test label */}
                        <div className="col-3">
                            <label className="margin-bottom-02em" htmlFor="txtPalLabel">
                                TestLabel3
                            </label>
                            <ReactSelectWrapper
                                data={labelsList}
                                isClearable={false}
                                styles={ReactSelectStyle}
                                onChange={e => {
                                    dispatch(
                                        onSetWorkorderLabels({
                                            ...workorderManagementRedux.labelsData,
                                            testPalletLabel3: e.value
                                        } as WorkorderLabel)
                                    );
                                }}
                                value={
                                    labelsList.find(
                                        (x: any) =>
                                            x.value.toLowerCase() === workorderManagementRedux.labelsData?.testPalletLabel3.toLowerCase()
                                    ) ?? null
                                }
                            />
                        </div>

                        {/* test label language */}
                        <div className="col-3">
                            <label className="margin-bottom-02em" htmlFor="txtPalLabel">
                                Language
                            </label>

                            <ReactSelectWrapper
                                data={languageSelectData}
                                isClearable={false}
                                styles={ReactSelectStyle}
                                onChange={e => {
                                    dispatch(
                                        onSetWorkorderLabels({
                                            ...workorderManagementRedux.labelsData,
                                            testPalletLabelLanguage3: e.value
                                        } as WorkorderLabel)
                                    );
                                }}
                                value={
                                    languageSelectData.find(
                                        (x: any) =>
                                            x.value.toLowerCase() ===
                                            workorderManagementRedux.labelsData?.testPalletLabelLanguage3.toLowerCase()
                                    ) ?? null
                                }
                            />
                        </div>
                    </div>

                    <div className="row" id="div-labels-selection-4">
                        {/* label */}
                        <div className="col-3">
                            <label className="margin-bottom-02em" htmlFor="txtPalLabel">
                                Label4
                            </label>
                            <ReactSelectWrapper
                                data={labelsList}
                                isClearable={false}
                                styles={ReactSelectStyle}
                                onChange={e => {
                                    dispatch(
                                        onSetWorkorderLabels({
                                            ...workorderManagementRedux.labelsData,
                                            palLabelName4: e.value
                                        } as WorkorderLabel)
                                    );
                                }}
                                value={
                                    labelsList.find(
                                        (x: any) =>
                                            x.value.toLowerCase() === workorderManagementRedux.labelsData?.palLabelName4.toLowerCase()
                                    ) ?? null
                                }
                            />
                        </div>
                        {/* label language */}
                        <div className="col-3">
                            <label className="margin-bottom-02em" htmlFor="txtPalLabel">
                                Language
                            </label>
                            <ReactSelectWrapper
                                data={languageSelectData}
                                isClearable={false}
                                styles={ReactSelectStyle}
                                onChange={e => {
                                    dispatch(
                                        onSetWorkorderLabels({
                                            ...workorderManagementRedux.labelsData,
                                            palLabelLanguage4: e.value
                                        } as WorkorderLabel)
                                    );
                                }}
                                value={
                                    languageSelectData.find(
                                        (x: any) =>
                                            x.value.toLowerCase() === workorderManagementRedux.labelsData?.palLabelLanguage4.toLowerCase()
                                    ) ?? null
                                }
                            />
                        </div>

                        {/* test label */}
                        <div className="col-3">
                            <label className="margin-bottom-02em" htmlFor="txtPalLabel">
                                TestLabel4
                            </label>
                            <ReactSelectWrapper
                                data={labelsList}
                                isClearable={false}
                                styles={ReactSelectStyle}
                                onChange={e => {
                                    dispatch(
                                        onSetWorkorderLabels({
                                            ...workorderManagementRedux.labelsData,
                                            testPalletLabel4: e.value
                                        } as WorkorderLabel)
                                    );
                                }}
                                value={
                                    labelsList.find(
                                        (x: any) =>
                                            x.value.toLowerCase() === workorderManagementRedux.labelsData?.testPalletLabel4.toLowerCase()
                                    ) ?? null
                                }
                            />
                        </div>

                        {/* test label language */}
                        <div className="col-3">
                            <label className="margin-bottom-02em" htmlFor="txtPalLabel">
                                Language
                            </label>

                            <ReactSelectWrapper
                                data={languageSelectData}
                                isClearable={false}
                                styles={ReactSelectStyle}
                                onChange={e => {
                                    dispatch(
                                        onSetWorkorderLabels({
                                            ...workorderManagementRedux.labelsData,
                                            testPalletLabelLanguage4: e.value
                                        } as WorkorderLabel)
                                    );
                                }}
                                value={
                                    languageSelectData.find(
                                        (x: any) =>
                                            x.value.toLowerCase() ===
                                            workorderManagementRedux.labelsData?.testPalletLabelLanguage4.toLowerCase()
                                    ) ?? null
                                }
                            />
                        </div>
                    </div>

                    <div className="row" id="div-labels-count">
                        <div className="col-3">
                            <label className="margin-bottom-02em" htmlFor="textbox-palLabelsPerPal">
                                {t("main.standard")}
                            </label>
                            <FormInputNumber name={"palLabelsPerPal"} value={workorderManagementRedux.labelsData?.palLabelsPerPal ?? 0} />
                        </div>
                        <div className="col-3">
                            <label className="margin-bottom-02em" htmlFor="textbox-userPalLabelsPerPal">
                                {t("main.operator")}
                            </label>
                            <FormInputNumber
                                name={"userPalLabelsPerPal"}
                                value={workorderManagementRedux.labelsData?.userPalLabelsPerPal ?? 0}
                            />
                        </div>
                    </div>
                    <br />
                    
                    <h5 className="mb-0">Test Label</h5>
                    <div className="row" id="div-labels-test-settings">
                        <div className="col-3">
                            <label className="margin-bottom-02em" htmlFor="textbox-testPalletStart">
                                Test Pallet Start
                            </label>
                            <FormInputNumber
                                name={"testPalletStart"}
                                value={workorderManagementRedux.labelsData?.testPalletStart ?? 0}
                            />
                        </div>
                        <div className="col-3">
                            <label className="margin-bottom-02em" htmlFor="textbox-testPalletRepeat">
                                Test Pallet Repeat
                            </label>
                            <FormInputNumber name={"testPalletRepeat"} value={workorderManagementRedux.labelsData?.testPalletRepeat ?? 0} />
                        </div>
                        <div className="col-3">
                            <label className="margin-bottom-02em" htmlFor="textbox-noTestPalletLabels">
                                Test Pallet Qty
                            </label>
                            <FormInputNumber
                                name={"noTestPalletLabels"}
                                value={workorderManagementRedux.labelsData?.noTestPalletLabels ?? 0}
                            />
                        </div>
                    </div>
                    <div className="row" id="div-labels-test-settings-string">
                        <div className="col-6">
                            <label className="margin-bottom-02em" htmlFor="textbox-testPalletText">
                                Test Pallet Text
                            </label>
                            <FormInputText name={"testPalletText"} value={workorderManagementRedux.labelsData?.testPalletText ?? ""} />
                        </div>
                    </div>

                    <div className="form-group row">
                        <div className="col-sm-10"></div>
                        <div className="col-sm-2">
                            <input
                                type="submit"
                                className="btn btn-primary float-right"
                                value={t("main.save")!}
                                disabled={!workorderManagementRedux.labelsDirty}
                            />
                        </div>
                    </div>
                </form>
            </div>
        </React.Fragment>
    );
}
